export const GRID_START_OFFSET = 108;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modules/specialOffer/content/constants.ts